import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'
import mutations from './mutations'
import { getVolume } from '@/plugins/jwtService'
import { DISPATCH_DELETE, DISPATCH_UPDATE } from "@/store/action-types";
import { SET_LOADING } from "@/store/mutation-types";
import ApiService from "@/plugins/ApiService";
import { uniqueKey } from "@/plugins/utils";


Vue.use(Vuex)


const state = {
    errors: {},
    loading: false,
    isPlaying: false,
    volume: getVolume() || 55,
    key: uniqueKey()

}

const actions = {
    [DISPATCH_DELETE]({ commit }, { url, items }) {

        commit(SET_LOADING, true)
        return new Promise((resolve, reject) => {
            ApiService.delete(url, { items })
                .then(response => {
                    commit(SET_LOADING, false)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })

        })
    },

    [DISPATCH_UPDATE]({ commit }, { data, url }) {

        commit(SET_LOADING, true)
        return new Promise((resolve, reject) => {
            ApiService.put(url, data)
                .then(response => {
                    commit(SET_LOADING, false)
                    resolve(response.data)

                })
                .catch((e) => {
                    commit(SET_LOADING, false)
                    reject(e)
                })

        })
    },
}


export const store = new Vuex.Store({
    state,
    mutations,
    actions,
    modules,
})